export const addLogType = log => ({ type: 'ADD_LOG_TYPE', payload: log }); // eslint-disable-line
